/**
 * 财务管理模块路由
 * 路径前缀: /desktopCenter/systemLog/
 */
import type { RouteRecordRaw } from "vue-router";

export const financeManageRoutes: RouteRecordRaw[] = [
	{
		path: "/desktopCenter/financeManage/manualTopUp",
		name: "ManualTopUp",
		meta: {
			title: "人工充值",
			keepAlive: false,
		},
		component: () => import("@main/views/Apps/FinanceManage/ManualTopUp/ManualTopUp.vue"),
	},
];
